<template lang="pug">

  nav.sosNav(:class="{ 'sosNav--disabled': disabled }")

    //- nav.sosNav(v-if="pagesCount > 1")

    //-
      - BOTÃO "ANTERIOR"
      -

    .sosNavColumn--button.sosNavColumn--textLeft
      a(@click.prevent="goToPrevPage" :class="{ 'disabled': pageNumber === 0 }")
        i.mdi.mdi-arrow-left.sosNavigatorIconSize(aria-hidden="true")

    //-
      - PAGINAÇÃO
      -

    //- PAGINAÇÃO COMPLETA
    .sosNavColumn--pages(v-if="isFullPagination")
      span
        a(v-for="page in pages" @click.prevent="goToPage(page)" :class="{ 'current': pageNumber === Number(page) - 1 }") {{ page }}
    //- PAGINAÇÃO PARCIAL: COMEÇO
    .sosNavColumn--pages(v-else-if="isPaginationStarting")
      span
        a(v-for="page in pages" @click.prevent="goToPage(page)" :class="{ 'current': pageNumber === Number(page) - 1 }") {{ page }}
        i.separator {{ '...' }}
        a(@click.prevent="goToPage(pagesCount)" :class="{ 'current': pageNumber === pagesCount }") {{ pagesCount }}
    //- PAGINAÇÃO PARCIAL: FINAL
    .sosNavColumn--pages(v-else-if="isPaginationEnding")
      span
        a(@click.prevent="goToPage(1)" :class="{ 'current': pageNumber === 0 }") {{ '1' }}
        i.separator {{ '...' }}
        a(v-for="page in pages" @click.prevent="goToPage(page)" :class="{ 'current': pageNumber === Number(page) - 1 }") {{ page }}
    //- PAGINAÇÃO PARCIAL: MEIO
    .sosNavColumn--pages(v-else)
      span
        a(@click.prevent="goToPage(1)" :class="{ 'current': pageNumber === 0 }") {{ '1' }}
        i.separator {{ '...' }}
        a(v-for="page in pages" @click.prevent="goToPage(page)" :class="{ 'current': pageNumber === Number(page) - 1 }") {{ page }}
        i.separator {{ '...' }}
        a(@click.prevent="goToPage(pagesCount)" :class="{ 'current': pageNumber === pagesCount }") {{ pagesCount }}

    //-
      - BOTÃO "PRÓXIMO"
      -

    .sosNavColumn--button.sosNavColumn--textRight
      a(@click.prevent="goToNextPage" :class="{ 'disabled': pageNumber === pagesCount - 1 }")
        i.mdi.mdi-arrow-right.sosNavigatorIconSize(aria-hidden="true")

</template>

<script>

  // const pageSize = 10
  const step = 2 // 3

  const fillArraySequentially = length => Array.from({ length }, (_, index) => String(index + 1))

  export default {
    name: 'SosNavigation',

    props: {
      disabled: {
        type: Boolean,
        default: () => false,
      },
      pagesCount: {
        type: Number,
        default: () => 0,
      },
      pageNumber: {
        type: Number,
        default: () => 0,
      },
    },

    /* data () {
      return {
        pageNumber: 0,
        pagesCount: 0,
      }
    }, */

    computed: {
      /* pagesCount: function () {
        return this.paginationButtons.length
      }, */

      // O navigator tem até 8 páginas? // 11

      isFullPagination: function () {
        return this.pagesCount < (step * 2) + 4 // 5 // 6
      },

      // Jesus
      // A página atual é menor que 7? Então está no começo da navegação.

      isPaginationStarting: function () {
        return this.pageNumber < (step * 2)
      },

      // A página atual é maior que TOTAL - 6, exemplo: "Em 30 páginas, está entre a página 25 e 30", então está no final da navegação.
      isPaginationEnding: function () {
        return this.pageNumber > this.pagesCount - (step * 2) /* CORREÇÃO para step = 2 */ - 1 /* CORREÇÃO para step = 2 */
      },

      startPage: function ()
      {
        return this.isFullPagination ? 0 : (
          this.isPaginationStarting ? 0 : (
            this.isPaginationEnding ? (
              this.pagesCount - (step * 2) - 2
            ) : (
              this.pageNumber - step
            )
          )
        )
      },

      endPage: function () {
        return this.isFullPagination ? (
          this.pagesCount + 1
        ) : (
          this.isPaginationStarting ? (
            ((step * 2) + 2 /* 3 / 4 */) - 1 /* Senhor Jesus */
          ) : (
            this.isPaginationEnding ? (
              this.pagesCount + 1
            ) : (
              this.pageNumber + step + 1
            )
          )
        )
      },

      pages: function () {
        // console.log('::: pages:', this.startPage, this.endPage)

        return fillArraySequentially(this.pagesCount).slice(this.startPage, this.endPage)
      },
    },

    methods: {
      //
      //
      //

      goToPrevPage ()
      {
        if (this.disabled) return false

        if (this.pageNumber - 1 <= -1) return false

        const pageNumber = this.pageNumber > 0 ? (this.pageNumber - 1) : 0

        this.$emit('onClickPrevPageButton', pageNumber)
      },

      goToNextPage ()
      {
        if (this.disabled) return false

        if (this.pageNumber + 1 >= this.pagesCount) return false

        const pageNumber = this.pageNumber >= this.pagesCount - 1 ? (this.pagesCount - 1) : this.pageNumber + 1

        this.$emit('onClickNextPageButton', pageNumber)
      },

      // SET PAGE

      goToPage (page)
      {
        if (this.disabled) return false

        const pageNumber = Number(page) - 1

        if (this.pageNumber === pageNumber) return false

        this.$emit('onClickPageButton', pageNumber)
      },
    },
  }

</script>

<style scoped lang="scss">

  //
  //
  //

  .sosNavigatorIconSize {
    font-size: 14px;
  }

  .sosNav {
    position: relative;

    display: inline-block;
    vertical-align: middle;
    width: 100%;
    padding: 3px 5px 6px 5px;
    border-radius: 4px;
    border-top: 1px solid #AEAEAE;
    border-bottom: 1px solid #FFFFFF;
    background-color: #DADADA;
    background-image: -webkit-linear-gradient(to top, #DBDBDB, #E2E2E2);
    background-image: -moz-linear-gradient(to top, #DBDBDB, #E2E2E2);
    background-image: -ms-linear-gradient(to top, #DBDBDB, #E2E2E2);
    background-image: -o-linear-gradient(to top, #DBDBDB, #E2E2E2);
    background-image: linear-gradient(to top, #DBDBDB, #E2E2E2);

    &--disabled {
      opacity: 0.5;
    }

    i.separator {
      display: inline-block;
      vertical-align: bottom;
      padding: 0 5px;

      font-size: 15px;
      line-height: 1;
    }

    a {
      user-select: none;

      cursor: pointer;

      display: inline-block;
      vertical-align: middle;
      min-width: 40px;
      margin: 3px;
      padding: 7px 0 5px 0;
      // min-width: 35px;
      // padding: 7px 7px 5px 7px;
      border-radius: 4px;
      box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.3);
      background-color: #f5f5f5;

      color: #7D7D7D;
      text-align: center;
      font-size: 15px;
      line-height: 1;

      // display: inline-block;
      // vertical-align: middle;
      // min-width: 35px;
      // color: #7D7D7D;
      // text-align: center;
      // font-size: 14px;
      // line-height: 14px;
      // padding: 7px 7px 5px 7px;
      // -webkit-user-select: none;
      // -moz-user-select: none;
      // -ms-user-select: none;
      // -o-user-select: none;
      // user-select: none;

      // margin: 2px;
      // border-radius: 4px;
      // border: 1px solid #E3E3E3;
      // cursor: pointer;
      // box-shadow: inset 0 1px 0 0 #FFF, 0 1px 2px #666;
      // text-shadow: 0 1px 1px #FFF;
      // background-color: #E6E6E6;
      // background-image: -webkit-linear-gradient(to top, #F3F3F3, #D7D7D7);
      // background-image: -moz-linear-gradient(to top, #F3F3F3, #D7D7D7);
      // background-image: -ms-linear-gradient(to top, #F3F3F3, #D7D7D7);
      // background-image: -o-linear-gradient(to top, #F3F3F3, #D7D7D7);
      // background-image: linear-gradient(to top, #F3F3F3, #D7D7D7);

      &.disabled
      {
        opacity: 0.5;
      }

      &.current
      {
        cursor: default;

        background-color: steelblue;

        color: white;

        // cursor: default;
        // border: 1px solid #E9E9E9;
        // background-image: -webkit-linear-gradient(to top, #D0D0D0, #EBEBEB);
        // background-image: -moz-linear-gradient(to top, #D0D0D0, #EBEBEB);
        // background-image: -ms-linear-gradient(to top, #D0D0D0, #EBEBEB);
        // background-image: -o-linear-gradient(to top, #D0D0D0, #EBEBEB);
        // background-image: linear-gradient(to top, #D0D0D0, #EBEBEB);
        // background-color: #DFDFDF;
        // box-shadow: 0 1px 1px #999;
      }
    }

    > div {
      display: inline-block;
      vertical-align: middle;
      text-align: center;
    }

    .sosNavColumn--button {
      position: absolute;
      top: 3px;

      &.sosNavColumn--textLeft {
        left: 5px;
        text-align: left;
      }

      &.sosNavColumn--textRight {
        right: 5px;
        text-align: right;
      }
    }
  }

  .sosNavColumn--pages {
    width: 100%;
    padding: 0px 45px;

    &> button {
      margin: 0 2.5px;
    }
  }

  .userManagerNavItem {
    display: inline-block;
    vertical-align: bottom;
    width: 25px;
    height: 13px;

    color: #e54245;
    font-size: 13px;
    line-height: 13px;
    font-weight: 600;
  }

</style>
